const rootstyles = {
    root: {
        minHeight: '80vh',
        padding: '24px 8px',
    },
    label: {
        textTransform: 'capitalize',
    },
};

export default (rootstyles);